exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pay_code[data-v-412c845a] {\n    width: 100%;\n.top,\n    .bottom {\n        background: #ffffff;\n        -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);\n                box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);\n        border-radius: 5px;\n        padding: 20px 50px;\n        margin-top: 20px;\n}\n.bottom {\n        padding: 50px 0;\n}\n.code_wrap {\n        width: 270px;\n        text-align: center;\n        margin: auto;\n        border: 1px solid #d3d3d3;\n}\n}\n", ""]);

// exports
